import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import LandingPage from "@/pages/LandingPage";
import ChatInterface from "@/pages/ChatInterface";
import IntakeFlow from "@/pages/IntakeFlow";
import IntakeSuccess from "@/pages/IntakeSuccess";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import LeadDetail from "@/pages/LeadDetail";
import SharedLeadView from "@/pages/SharedLeadView";
import TermsPage from "@/pages/TermsPage";
import AttorneyLogin from "@/pages/attorney/AttorneyLogin";
import AttorneySignup from "@/pages/attorney/AttorneySignup";
import AttorneyDashboard from "@/pages/attorney/AttorneyDashboard";
import AttorneyLeadDetail from "@/pages/attorney/AttorneyLeadDetail";
import Subscribe from "@/pages/attorney/Subscribe";
import { ThemeProvider } from "@/lib/theme-context";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("adminToken");
  return token ? children : <Navigate to="/admin/login" replace />;
}

function AttorneyRoute({ children }) {
  const token = localStorage.getItem("attorneyToken");
  return token ? children : <Navigate to="/attorney/login" replace />;
}

function App() {
  return (
    <HelmetProvider>
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Client intake flow */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/intake" element={<ChatInterface />} />
            <Route path="/intake/success" element={<IntakeSuccess />} />

            {/* Public shared lead view — read-only, no auth */}
            <Route path="/share/lead/:token" element={<SharedLeadView />} />

            {/* Admin portal */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Navigate to="/admin/login" replace />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/leads/:leadId" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />

            {/* Attorney portal — completely separate from client flow */}
            <Route path="/attorney/login" element={<AttorneyLogin />} />
            <Route path="/attorney/signup" element={<AttorneySignup />} />
            <Route path="/attorney" element={<Navigate to="/attorney/login" replace />} />
            <Route path="/attorney/dashboard" element={<AttorneyRoute><AttorneyDashboard /></AttorneyRoute>} />
            <Route path="/attorney/leads/:leadId" element={<AttorneyRoute><AttorneyLeadDetail /></AttorneyRoute>} />
            <Route path="/attorney/subscribe" element={<AttorneyRoute><Subscribe /></AttorneyRoute>} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
